import { render, staticRenderFns } from "./viewImgDialog.vue?vue&type=template&id=35403366"
import script from "./viewImgDialog.vue?vue&type=script&lang=js"
export * from "./viewImgDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports